'use strict';

var configuratorHelpers = require('./configuratorHelpers');

// ─── Module-level flags ───────────────────────────────────────────────────────
var saveBuildDataLayerPushed = false;

/**
 * Selected-model payload for save-build events. Returns null when the summary
 * attribute is empty or the product shape cannot be read — callers must still push.
 * @returns {Object|null}
 */
function readSaveBuildSelectedModel() {
    try {
        var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
        if (!summaryDataJSON) {
            return null;
        }
        var summaryData = JSON.parse(summaryDataJSON);
        var productData = summaryData && summaryData.data && summaryData.data.product;
        if (!productData || !productData.customProps) {
            return null;
        }
        return configuratorHelpers.buildConfiguratorSelectedModel(productData, window.globalAccessoryData || []);
    } catch (e) {
        return null;
    }
}

/**
 * Save build succeeded (SaveBuild-SaveAndShareLead). Key-event strings are lowercase —
 * that is what the GA4 trigger matches.
 */
function pushSaveBuildComplete() {
    var loc = configuratorHelpers.getConfiguratorLocation();
    var selectedModel = readSaveBuildSelectedModel();
    var configuratorId = typeof window.globalSaveuniqueCode === 'string' ? window.globalSaveuniqueCode : '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'custom.form',
        'group': 'save build',
        'category': 'configurator',
        'action': 'complete my honda',
        'data': {
            'configurator ID': configuratorId,
            'location': loc.formattedAddress,
            'postcode': loc.postalCode,
            'dealer': loc.dealerName
        },
        models: selectedModel ? [selectedModel] : []
    });
}

// ─── Event Handlers ───────────────────────────────────────────────────────────

var events = {

    configuratorSaveAndShare: function (data) {
        var loc = configuratorHelpers.getConfiguratorLocation();
        var productData = JSON.parse($('.js-save-summary').attr('data-car-summary-data')).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, window.globalAccessoryData || []);

        window.saveBuildUUID = crypto.randomUUID();
        sessionStorage.setItem('formStartTime_saveBuild', String(Date.now()));

        dataLayer.push({ 'event': 'custom.cta', 'group': 'build', 'category': 'configurator', 'action': 'click', 'label': data.text().trim() + ' And Share' });
        dataLayer.push({
            'event': 'custom.form', 'group': 'Save build', 'category': 'configurator', 'action': 'view',
            'userRequestId': window.saveBuildUUID,
            'data': { 'configurator ID': window.globalSaveuniqueCode || '', 'location': loc.formattedAddress, 'postcode': loc.postalCode, 'dealer': loc.dealerName },
            models: [selectedModel]
        });
    },

    configuratorSummary: function (data) {
        dataLayer.push({ 'event': 'custom.cta', 'group': 'build', 'category': 'configurator', 'action': 'click', 'label': 'View ' + data.text().trim() });
    },

    configuratorSaveBuildComplete: function () {
        pushSaveBuildComplete();
    },

    configureSaveBuildFormStart: function () {
        if (!window.saveBuildUUID && window.crypto && typeof crypto.randomUUID === 'function') {
            window.saveBuildUUID = crypto.randomUUID();
        }

        var form = document.querySelector('#configurator-save-and-share');
        if (!form) return;

        var loc = configuratorHelpers.getConfiguratorLocation();
        var selectedModel = readSaveBuildSelectedModel();

        // First input interaction on the share form fires 'start'
        form.addEventListener('input', function () {
            if (!saveBuildDataLayerPushed) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'custom.form', 'group': 'Save build', 'category': 'configurator', 'action': 'start',
                    'userRequestId': window.saveBuildUUID,
                    'data': { 'configurator ID': typeof window.globalSaveuniqueCode === 'string' ? window.globalSaveuniqueCode : '', 'location': loc.formattedAddress, 'postcode': loc.postalCode, 'dealer': loc.dealerName },
                    models: selectedModel ? [selectedModel] : []
                });
                saveBuildDataLayerPushed = true;
            }
        });
    },

    accordSpecSheet: function (data) {
        var carBuildBtn = document.querySelector('#carbuildbtn-primary');
        var carName = carBuildBtn ? carBuildBtn.textContent.replace('Build ', '').replace('Your ', '').replace('your ', '').trim() : '';
        dataLayer.push({ 'event': 'custom.cta', 'group': 'hero', 'category': carName + ' Showroom Page', 'action': 'click', 'label': 'View Spec Sheet - ' + carName });
    },

    viewKeyFeatures: function (data) {
        var model = document.querySelector('.font-weight-bolder') ? document.querySelector('.font-weight-bolder').textContent.trim().replace('Customise your', '') : '';
        var variant = document.querySelector('.modal-title_variant_name_title') ? document.querySelector('.modal-title_variant_name_title').textContent.trim() : '';
        dataLayer.push({ 'event': 'custom.cta', 'group': 'build', 'category': 'configurator', 'action': 'click', 'label': 'View Key Features -' + model + ' - ' + variant });
    },

    downloadSpecSheet: function (data) {
        var model = document.querySelector('.font-weight-bolder') ? document.querySelector('.font-weight-bolder').textContent.trim().replace('Customise your', '') : '';
        var variant = document.querySelector('.modal-title_variant_name_title') ? document.querySelector('.modal-title_variant_name_title').textContent.trim() : '';
        dataLayer.push({ 'event': 'custom.cta', 'group': 'build', 'category': 'configurator', 'action': 'click', 'label': 'View Spec sheet -' + model + ' - ' + variant });
    }
};

module.exports = { events: events };
